export default __webpack_public_path__ + "static/media/happy_canary.79d1026a.png";